// Mirrors the opportunity list filter (OpportunityListSearchCriteria) so the
// campaign browse uses the same filtering. Status is fixed to Open — a campaign
// targets live pipeline. Only snapshot opportunity contacts are returned
// (prospectContactOnly is enforced server-side by the browse action).
export default class CampaignOpportunitySearchViewModel {
    branchId: string | null = null;
    deskId: string | null = null;
    ownerId: string | null = null;
    workTypes: string[] = [];
    locationTypeIds: string[] = [];
}
